<template>
  <div class="product-variations">
    <label for="variations">Talla:</label>
    <select
      v-model="selected"
      @change="changeQuantity(selected)"
      id="variations"
      class="form-control"
    >
      <option disabled value="">Seleccionar</option>
      <option v-for="elem in variations" :key="elem.id" :value="elem">
        {{ elem.searchCode | sizes }}
      </option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    variations: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    sizes(value) {
      if (!value) return '';
      const elem = value.split(':');
      return elem[1];
    }
  },
  data() {
    return {
      selected: ''
    };
  },
  created(){
    const defaultVariation = this.variations[0];
    if(defaultVariation){
      this.changeQuantity(defaultVariation);
      this.selected = defaultVariation;
    }
  },  
  methods: {
    changeQuantity(value) {
      this.$emit('assignVariations', value);
    }
  }
};
</script>
<style lang="scss">
.product-variations {
  display: flex;
  align-content: center;
  align-items: center;
  margin-bottom: 1rem;
  padding-right: 10px;
  label {
    margin-bottom: 0;
    margin-right: 10px;
  }
}
</style>
